import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as R from "ramda";

import {Chart as DXChart} from 'devextreme-react/chart';
import ReactDOM from "react-dom";


export default class Chart extends Component {
    constructor(props) {
        super(props);

        this.customizeText = this.customizeText.bind(this);
        this.templateLabel = this.templateLabel.bind(this);
        this.customizeTooltip = this.customizeTooltip.bind(this);

        this.onLegendClick = this.onLegendClick.bind(this);
        this.onPointClick = this.onPointClick.bind(this);
        this.onSeriesClick = this.onSeriesClick.bind(this);
    }

    // componentDidMount() {
    //     window.addEventListener('resize', this.resizeEvent);
    // }
    //
    // componentWillUnmount() {
    //     window.removeEventListener('resize', this.resizeEvent);
    // }

    customizeText(obj) {
        if (typeof obj === 'object' && obj.label && obj.label.customizeText) {
            if (window[obj.label.customizeText]) {
                obj.label.customizeText = window[obj.label.customizeText];
            }
        }
    }

    templateLabel(obj) {
        if (typeof obj === 'object' && obj.label && obj.label.template) {
            if (window[obj.label.template]) {
                var tmpl = window[obj.label.template];
                obj.label.template = function(props, element) {
                    ReactDOM.render(tmpl(props), element);
                }
            }
        }
    }

    customizeTooltip(tooltip) {
        if (typeof tooltip === 'object' && tooltip.customizeTooltip) {
            if (window[tooltip.customizeTooltip]) {
                tooltip.customizeTooltip = window[tooltip.customizeTooltip];
            }
        }
    }

    onLegendClick({ target: series }) {
        // console.log(series)
        if(series.isVisible()) {
            series.hide();
        } else {
            series.show();
        }
    }

    onPointClick(e) {
        // console.log('onPointClick', e)
        const {setProps} = this.props;

        if (setProps) {
            setProps({
                pointClick: {
                    data: e.target.data,
                    index: e.target.index,
                    series: {
                        index: e.target.series.index,
                        name: e.target.series.name,
                        type: e.target.series.type,
                        valueType: e.target.series.valueType,
                    },
                    timestamp: Date.now()
                }
            });
        }
    }

    onSeriesClick(e) {
        // console.log('onSeriesClick', e)
        const {setProps} = this.props;

        /*if (setProps) {
            setProps({
                pointClick: {
                    data: e.data,
                    key: e.key,
                    timestamp: Date.now()
                }
            });
        }*/
    }

    render() {
        const dataAttributes = {};
        if (this.props.loading_state && this.props.loading_state.is_loading) {
            dataAttributes['data-dash-is-loading'] = true;
        }
        const {series, tooltip, valueAxis, argumentAxis} = this.props;
        let {onPointClick, customizePoint, customizeLabel} = this.props;
        if (series) {
            if (Array.isArray(series)) {
                for(let i=0; i < series.length; i++) {
                    this.customizeText(series[i]);
                }
            } else {
                this.customizeText(series);
            }
        }
        if (valueAxis) this.customizeText(valueAxis);
        if (argumentAxis) {
            this.customizeText(argumentAxis);
            this.templateLabel(argumentAxis);
        }
        if (tooltip) this.customizeTooltip(tooltip);
        if (customizePoint && typeof customizePoint === 'string' && window[customizePoint])
            customizePoint = window[customizePoint];
        if (customizeLabel && typeof customizeLabel === 'string' && window[customizeLabel])
            customizeLabel = window[customizeLabel];
        if (onPointClick && typeof onPointClick === 'string')
            onPointClick = window[onPointClick];

        return (
            <DXChart
                {...R.omit(['loading_state', 'setProps'], this.props)}
                {...dataAttributes}
                onLegendClick={this.props.onLegendClick || this.onLegendClick}
                onPointClick={onPointClick || this.onPointClick}
                customizeLabel={customizeLabel}
                customizePoint={customizePoint}
                //onSeriesClick={this.props.onSeriesClick || this.onSeriesClick}
            />
        )
    }
}

Chart.propTypes = {
    /**
     * The ID used to identify this component in Dash callbacks
     */
    id: PropTypes.string,

    adaptiveLayout: PropTypes.object,
    adjustOnZoom: PropTypes.bool,
    animation: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
    annotations: PropTypes.arrayOf(PropTypes.object),
    argumentAxis: PropTypes.object,
    autoHidePointMarkers: PropTypes.bool,
    barGroupPadding: PropTypes.number,
    barGroupWidth: PropTypes.number,
    commonAnnotationSettings: PropTypes.object,
    commonAxisSettings: PropTypes.object,
    commonPaneSettings: PropTypes.object,
    commonSeriesSettings: PropTypes.object,
    containerBackgroundColor: PropTypes.string,
    crosshair: PropTypes.object,
    customizeAnnotation: PropTypes.func,
    customizeLabel: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    customizePoint: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    dataPrepareSettings: PropTypes.object,
    dataSource: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.any), PropTypes.object, PropTypes.string]),
    defaultPane: PropTypes.string,
    disabled: PropTypes.bool,
    elementAttr: PropTypes.object,
    export: PropTypes.object,
    legend: PropTypes.object,
    loadingIndicator: PropTypes.object,
    margin: PropTypes.object,
    maxBubbleSize: PropTypes.number,
    minBubbleSize: PropTypes.number,
    negativesAsZeroes: PropTypes.bool,
    onArgumentAxisClick: PropTypes.func,
    onDisposing: PropTypes.func,
    onDone: PropTypes.func,
    onDrawn: PropTypes.func,
    onExported: PropTypes.func,
    onExporting: PropTypes.func,
    onFileSaving: PropTypes.func,
    onIncidentOccurred: PropTypes.func,
    onInitialized: PropTypes.func,
    onLegendClick: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    onOptionChanged: PropTypes.func,
    onPointClick: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    onPointHoverChanged: PropTypes.func,
    onPointSelectionChanged: PropTypes.func,
    onSeriesClick: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    onSeriesHoverChanged: PropTypes.func,
    onSeriesSelectionChanged: PropTypes.func,
    onTooltipHidden: PropTypes.func,
    onTooltipShown: PropTypes.func,
    onZoomEnd: PropTypes.func,
    onZoomStart: PropTypes.func,
    palette: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.oneOf(['Bright', 'Harmony Light', 'Ocean', 'Pastel', 'Soft', 'Soft Pastel', 'Vintage', 'Violet', 'Carmine', 'Dark Moon', 'Dark Violet', 'Green Mist', 'Soft Blue', 'Material', 'Office'])]),
    paletteExtensionMode: PropTypes.oneOf(['alternate', 'blend', 'extrapolate']),
    panes: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.object), PropTypes.object]),
    pathModified: PropTypes.bool,
    /**
     * Dash event
     */
    pointClick: PropTypes.object,
    pointSelectionMode: PropTypes.oneOf(['multiple', 'single']),
    redrawOnResize: PropTypes.bool,
    resizePanesOnZoom: PropTypes.bool,
    resolveLabelOverlapping: PropTypes.oneOf(['hide', 'none', 'shift']),
    rotated: PropTypes.bool,
    rtlEnabled: PropTypes.bool,
    scrollBar: PropTypes.object,
    series: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.object)]),
    seriesSelectionMode: PropTypes.oneOf(['multiple', 'single']),
    seriesTemplate: PropTypes.object,
    size: PropTypes.object,
    stickyHovering: PropTypes.bool,
    synchronizeMultiAxes: PropTypes.bool,
    theme: PropTypes.oneOf(['generic.dark', 'generic.light', 'generic.contrast', 'ios7.default', 'generic.carmine', 'generic.darkmoon', 'generic.darkviolet', 'generic.greenmist', 'generic.softblue', 'material.blue.light', 'material.lime.light', 'material.orange.light', 'material.purple.light', 'material.teal.light']),
    title: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    tooltip: PropTypes.object,
    valueAxis: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.object)]),
    zoomAndPan: PropTypes.object,

    // Dash-assigned callback that gets fired when the value changes.
    setProps: PropTypes.func,
    /**
     * Object that holds the loading state object coming from dash-renderer
     */
    loading_state: PropTypes.shape({
        /**
         * Determines if the component is loading or not
         */
        is_loading: PropTypes.bool,
        /**
         * Holds which property is loading
         */
        prop_name: PropTypes.string,
        /**
         * Holds the name of the component that is loading
         */
        component_name: PropTypes.string,
    }),
};

Chart.defaultProps = {
    adaptiveLayout: {},
    adjustOnZoom: true,
    animation: {},
    annotations: [],
    argumentAxis: {},
    autoHidePointMarkers: true,
    barGroupPadding: 0.3,
    // barGroupWidth: undefined,
    commonAnnotationSettings: {},
    commonAxisSettings: {},
    commonPaneSettings: {},
    commonSeriesSettings: {},
    containerBackgroundColor: '#ffffff',
    crosshair: {},
    customizeAnnotation: null,
    customizeLabel: null,
    customizePoint: null,
    dataPrepareSettings: {},
    dataSource: null,
    // defaultPane: undefined,
    disabled: false,
    elementAttr: {},
    export: {},
    legend: {},
    loadingIndicator:  {},
    margin: {},
    maxBubbleSize: 0.2,
    minBubbleSize: 12,
    negativesAsZeroes: false,
    onArgumentAxisClick: null,
    onDisposing: null,
    onDone: null,
    onDrawn: null,
    onExported: null,
    onExporting: null,
    onFileSaving: null,
    onIncidentOccurred: null,
    onInitialized: null,
    onLegendClick: null,
    onOptionChanged: null,
    onPointClick: null,
    onPointHoverChanged: null,
    onPointSelectionChanged: null,
    onSeriesClick: null,
    onSeriesHoverChanged: null,
    onSeriesSelectionChanged: null,
    onTooltipHidden: null,
    onTooltipShown: null,
    onZoomEnd: null,
    onZoomStart: null,
    palette: 'Material',
    paletteExtensionMode: 'blend',
    panes: {},
    pathModified: false,
    pointSelectionMode: 'single',
    redrawOnResize: true,
    resizePanesOnZoom: false,
    resolveLabelOverlapping: 'none',
    rotated: false,
    rtlEnabled: false,
    scrollBar: {},
    series: [],
    seriesSelectionMode: 'single',
    // seriesTemplate: undefined,
    size: {},
    stickyHovering: true,
    synchronizeMultiAxes: true,
    theme: 'generic.light',
    title: {},
    tooltip: {},
    valueAxis: {},
    zoomAndPan: {}
};
